<!-- <mat-spinner></mat-spinner> -->
@if (change$ | async) {
  <mat-progress-bar
    mode="indeterminate"
  ></mat-progress-bar>
}
<div #gantt_here class="gantt-chart"></div>
<div
  style="visibility: hidden; position: fixed"
  [style.left]="contextMenuPosition.x"
  [style.top]="contextMenuPosition.y"
  [matMenuTriggerFor]="contextMenuTask"
></div>
<mat-menu #contextMenuTask="matMenu">
  <ng-template matMenuContent let-item="task">
    <button
      mat-menu-item
      (click)="showOfProperties(item)"
      [hidden]="currentTaskType !== 3"
      >

      <mat-icon>ballot</mat-icon>
      <span i18n>Properties</span>
    </button>
    <button mat-menu-item disabled [hidden]="currentTaskType !== 3">
      <mat-icon>square_foot</mat-icon>
      <span i18n>New production order</span>
    </button>
    <button mat-menu-item disabled [hidden]="currentTaskType !== 3">
      <mat-icon>delete_sweep</mat-icon>
      <span i18n>Delete production order</span>
    </button>
    <button
      mat-menu-item
      (click)="detailsComposants(item)"
      [hidden]="currentTaskType !== 3"
      >
      <mat-icon>settings_input_component</mat-icon>
      <span i18n>Components Details</span>
    </button>
    <button
      mat-menu-item
      (click)="showOpProperties(item)"
      [hidden]="currentTaskType !== 4"
      >
      <mat-icon>ballot</mat-icon>
      <span i18n>Properties</span>
    </button>
    <button mat-menu-item [hidden]="true">
      <mat-icon>ballot</mat-icon>
      <span i18n>HR</span>
    </button>
    <button mat-menu-item [hidden]="currentTaskType !== 2">
      <mat-icon>ballot</mat-icon>
      <span i18n>Staking</span>
    </button>
  </ng-template>
</mat-menu>
<!-- <ng-container i18n>Name</ng-container> -->
